import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

interface SEOProps {
  title?: string;
  description?: string;
  path?: string;
  type?: string;
  image?: string;
  noindex?: boolean;
}

const SITE_URL = "https://freelamedia.com";
const DEFAULT_IMAGE = "https://freelamedia.com/og-image.jpg";

const SEO = ({
  title,
  description,
  path = "/",
  type = "website",
  image = DEFAULT_IMAGE,
  noindex = false,
}: SEOProps) => {
  const { i18n } = useTranslation();
  const lang = i18n.language || "pt";
  const canonicalUrl = `${SITE_URL}${path}`;

  return (
    <Helmet>
      <html lang={lang} />
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={canonicalUrl} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content={lang === "pt" ? "pt_BR" : lang} />
      <meta property="og:site_name" content="Freela Media" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      {title && <meta name="twitter:title" content={title} />}
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={image} />

      {/* Hreflang alternates */}
      <link rel="alternate" hrefLang="pt" href={`${SITE_URL}${path}`} />
      <link rel="alternate" hrefLang="en" href={`${SITE_URL}${path}`} />
      <link rel="alternate" hrefLang="es" href={`${SITE_URL}${path}`} />
      <link rel="alternate" hrefLang="fr" href={`${SITE_URL}${path}`} />
      <link rel="alternate" hrefLang="de" href={`${SITE_URL}${path}`} />
      <link rel="alternate" hrefLang="it" href={`${SITE_URL}${path}`} />
      <link rel="alternate" hrefLang="x-default" href={`${SITE_URL}${path}`} />
    </Helmet>
  );
};

export default SEO;
